import React, { useCallback } from 'react'
import { useUpdateLog } from 'utils/log'

import DivideCarFourLine, {
  DivideCarFourLineProps,
  DivideCarFourPartKeyProps,
  isDivideCarFourPartKeyProps
} from '../../items/DamagedPartLine/DivideCarFourLine'
import { FormTitleProps } from '../../items/FormTitle'
import BaseGroup from '../BaseGroup'

/**
 * 対象がDivideCarFourGroupProps型かチェックする
 * @param target チェック対象
 */
export const isDivideCarFourGroupProps = (
  target: any
): target is DivideCarFourGroupProps => {
  return (
    target.damagedPart !== undefined &&
    target.title !== undefined &&
    Object.entries(target.damagedPart).every(([partKey]) =>
      isDivideCarFourPartKeyProps(partKey)
    )
  )
}

/**
 * 破損箇所グループ
 * 前後左右4分割の車
 */
const DivideCarFourGroup: React.FC<DivideCarFourGroupProps> = (props) => {
  const toggleDamagedPart = useCallback(
    (partKey: DivideCarFourPartKeyProps): void => {
      const state = { ...props.damagedPart }
      state[partKey].isDamaged = !state[partKey].isDamaged
      props.setDamagedPart && props.setDamagedPart(state)
    },
    [props]
  )

  useUpdateLog(
    props.title,
    {
      title: props.title,
      isRequired: props.isRequired,
      damagedPart: props.damagedPart,
    },
    [props]
  )

  return (
    <BaseGroup
      isRequired={props.isRequired}
      title={props.title}
      description={props.description}
    >
      <DivideCarFourLine
        {...props.damagedPart}
        toggleDamagedPart={toggleDamagedPart}
      />
    </BaseGroup>
  )
}

export type DivideCarFourGroupProps = FormTitleProps & {
  damagedPart: DivideCarFourLineProps
  formName: string
  setDamagedPart?: (sampleDamagedPart: DivideCarFourLineProps) => void
}

export default React.memo<DivideCarFourGroupProps>(DivideCarFourGroup)
